import styled from 'styled-components';

export const Container = styled.div`

  .check-button {
    cursor: pointer;
  }

  input[type=checkbox] {
      box-sizing: border-box;
      padding: 0;
  }

  input {
      outline: 0;
      background-color: transparent;
  }

  .check-button-input {
      opacity: 0;
      position: absolute;
  }

  .check-button-control {
    width: 11px;
    height: 11px;
    border-radius: 11px;
    border: 1px solid ${(props) => props.theme.colors.secondary};
    background: inherit;
    vertical-align: middle;
    display: inline-block;
    margin-right: 7px;
    margin-bottom: 2px;

    &.dark{
      border: 1px solid #ccc;
      background: #ccc;
    }
  }

  .check-button-input:checked+.check-button-control:after {
    content: "";
    display: block;
    top: 0px;
    left: 0px;
    width: 11px;
    height: 11px;
    border-radius: 11px;
    background-color: #00C6C9;
  }

  .check-button-input:checked+.check-button-control {
      border: 0;
  }


`;

export const Label = styled.label`
`;
